import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertService } from 'src/app/_alert';
import { AuthService } from 'src/app/_services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RefundService } from 'src/app/_services/refund.service';
import { CancelRefundSuccessComponent } from 'src/app/Product/cancelRefund/cancel-refund-success/cancel-refund-success.component';

@Component({
  selector: 'app-cancel-refund',
  templateUrl: './cancel-refund.component.html',
  styleUrls: ['./cancel-refund.component.css']
})
export class CancelRefundComponent implements OnInit {
  isLoading: boolean = false;

  constructor(
    public refundService: RefundService,
    public dialogRef: MatDialogRef<CancelRefundComponent>,
    public dialog: MatDialog,
    public alertService: AlertService,
    public authService: AuthService,
    public router: Router,
    @Inject(MAT_DIALOG_DATA) public data,
    private route: ActivatedRoute,
  ) { }

  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };
  transId: number;
  ngOnInit(): void {

  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  onClick() {
    this.isLoading = true;
    this.refundService.cancelRefund(this.data.refundRequestId).subscribe((response: any) => {
      console.log(response);
      const dialogRef = this.dialog.open(CancelRefundSuccessComponent, {
        width: '500px',
        disableClose: true
      });
      this.isLoading = false;
    }, (error) => {
      console.log(error);
    })
  }
}
